let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("eEPT4")).then(() => parcelRequire('jPcpM'));